import deleteService from "../deleteService";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";

const CONFIG_API_URL =
    process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";


export default class BadgeService {
    static async getActiveBadges() {
        const response = await getService.get(`${CONFIG_API_URL}badges`);
        const data: any = response.data;
        return data;
    }
    static async getRecievedBadges() {
        const response = await getService.get(`${CONFIG_API_URL}received-badges`);
        const data: any = response.data;
        return data;
    }
    
    static async getBadge(uuid: string | undefined) {
        const response = await getService.get(`${CONFIG_API_URL}badges/${uuid}`);
        const data: any = response.data;
        return data;
    }
    static async getUserBadges(uuid: string | undefined) {
        const response = await getService.get(`${CONFIG_API_URL}user/${uuid}/badges`);
        const data: any = response.data;
        return data;
    }
    static async createBadge(data: any) {
        const response = await postService.post(`${CONFIG_API_URL}badges`, data);
        return response.data;

    }
    static async assignBadge(data: any) {
        const response = await postService.post(`${CONFIG_API_URL}received-badges`, data);
        return response.data;

    }
    static async revokeBadge(uuid: any) {
        const response = await deleteService.delete(`${CONFIG_API_URL}received-badges/${uuid}`, );
        return response.data;

    }
    static async updateBadge(data: any, uuid: string | undefined) {
        const response = await putService.put(`${CONFIG_API_URL}badges/${uuid}`, data);
        return response.data;

    }
}
